import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Returns() {
  return (
    <div className="returns">
      <Header />

      <main>
        <div className="grid grid-cols-1 overflow-x-hidden ">
          <div>
            <div className="md:px-8 lg:px-12   ">
              <div className="pt-6">
                <div className="">
                  <div
                    __typename="ComponentComponentsText"
                    container="[object Object]"
                    id={7057}
                  >
                    <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                      <h1>Returns Information</h1>
                      <h2>Start A Return</h2>

                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          <strong>
                            Extended Christmas Returns: Any orders made after
                            6th November can be returned until 4th January.
                          </strong>
                        </p>
                      </div>
                      <h2>Gift Card Information</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You now have the option to choose gift card instead of
                          cash for your returns. Just use the boventraix returns
                          page as usual and select “gift card” as a method of
                          return. Sorry, but this option is not available for
                          goods that are faulty and you must contact customer
                          service as usual to return these items.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          <u>
                            <strong>
                              Important information about your credit refund
                            </strong>
                          </u>
                          Any customers who opt for gift card return will
                          receive 20% extra on their refund price. The cost of
                          your returns amount will be deducted from the full
                          amount of your refund. We are sorry but any customers
                          who made their purchase using gift card or a gift card
                          will not receive the 20% extra on their refund price.{" "}
                          <u>
                            Please note that if you select gift card as your
                            preferred option, it will only be valid for a period
                            of 90 days from the date you receive it.
                          </u>
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Once you select to receive a gift card refund you
                          cannot alter this selection. If you are returning
                          multiple items from one order, under separate returns,
                          the choice you make for your first return will apply
                          to all other returns from the same order regardless of
                          when you return this. For example, if you select “gift
                          card return” for the first item from this order, you
                          will receive a gift card on all additional returns you
                          make from this order
                        </p>
                      </div>
                      <h2>
                        How to return an item &amp; how much does it cost?
                      </h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please note a returns charge of £1.99 per parcel will
                          be deducted from your refund amount. The process for
                          returning your products is dependant on whether the
                          individual item was supplied by boventraix or by a
                          Concession Brand.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Premier customers are limited to one free return per
                          order. Additional returns for the same order will be
                          charged when you shop through boventraix.space.
                        </p>
                      </div>
                      <h3>
                        For items supplied under a contract with boventraix:
                      </h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please use a trackable service and keep your proof of
                          postage receipt until after your refund is processed.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You've got 28 days to send something back to us from
                          the day you receive it.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you’ve received an item that’s not in perfect
                          condition please head over to our {" "}
                          <Link onClick={toTop} to="/contact">
                            Contact Us
                          </Link>{" "}
                           section so we can get this fixed for you.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          No packaging, no problem! Just pop your items in
                          something non see-through, sealable &amp; waterproof.
                          Items must be unwashed, unworn and with the original
                          labels still attached
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please keep your orders separate, as returning more
                          than 1 order in 1 parcel may delay your refund.
                        </p>
                      </div>
                      <ol>
                        <li>Repack your items.</li>
                        <li>
                          Login to our returns portal. You will need your order
                          number and email/postcode.
                        </li>
                        <li>
                          Select your preferred return option (Print returns
                          label at home or in store options).
                        </li>
                        <li>
                          Once you have processed your return in the portal
                          you're ready to post it off! Make sure you keep proof
                          of postage!
                        </li>
                        <li>
                          Keep an eye on your return tracking. You'll get an
                          email once we receive your returned item.
                        </li>
                      </ol>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          <Link onClick={toTop} to="/returns">
                            Start a return now
                          </Link>
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We've gone paperless! You'll no longer receive a
                          delivery note in your parcel.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For hygiene reasons, we cannot offer refunds on
                          fashion face masks, cosmetics (including beauty
                          products), pierced jewellery, swimwear or lingerie (if
                          the hygiene or product seal has been broken or is no
                          longer in place). Items must be unworn and unwashed
                          with the original labels attached. This does not
                          affect your statutory rights.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Unfortunately we don't offer an exchange facility.
                          Simply return your item(s) and reorder for a
                          replacement. Your refund will be processed once we've
                          received your unwanted items.
                        </p>
                      </div>
                      <h2>
                        For items supplied under a contract with a
                        Concessionaire Partners:
                      </h2>
                      <h3>Products bought from DBZ Brands:</h3>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please return the item direct to the Concessionaire
                          Brand that supplied the item by using their returns
                          process. To do so, please follow the instructions
                          provided to return your item that are set out in the
                          delivery note enclosed in your parcel or via this{" "}
                          <Link onClick={toTop} to="/returns">
                            link
                          </Link>
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please note a one off return fee of £1.99 will be
                          deducted from your refund amount.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          You will receive a confirmation email once the
                          Concessionaire Brand has received your parcel and a
                          refund has been processed by the Concessionaire Brand.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Unfortunately we don't offer an exchange facility.
                          Simply return your item(s) and reorder for a
                          replacement. Your refund will be processed once we've
                          received your unwanted items.
                        </p>
                      </div>
                      <h2>
                        For items supplied under a contract with boventraix and
                        Our Concession Partners
                      </h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          In the event of a single order consiting of multiple
                          items in which some items are deliverd by boventraix
                          and some by our Concession Partners, a £1.99 fee will
                          be charged per parcel for any boventraix items
                          returned. A one off fee of £1.99 will be charged for
                          any concession items (regardless of the number of
                          parcels or number of partners you are returning to)
                        </p>
                      </div>
                      <h2>When will I receive my refund?</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          As soon as we receive your order back we get to work
                          on processing your return and issuing the refund back
                          to the refund method that was selected when logging
                          the return.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you chose refund to original payment method, this
                          will be processed back to the payment method used when
                          placing the order.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you chose refund to gift card, once your return has
                          been processed, you'll receive an email containing the
                          gift card.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For any DBZ brand partner returns, refunds will be
                          processed back to the original payment method used
                          when placing the order.
                        </p>
                      </div>
                      <h2>Returns Policy</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          This Returns Policy applies to goods ordered online at{" "}
                          <Link onClick={toTop} to="/">
                            www.boventraix.space
                          </Link>{" "}
                          under a contract with boventraix Online Limited
                          ("boventraix") and goods ordered under a contract with
                          a third party seller that sells goods on our website{" "}
                          <Link onClick={toTop} to="/">
                            www.boventraix.space
                          </Link>{" "}
                          or in store (a "Concessionaire Brand"). References in
                          this Returns Policy to "we", "us" or "our" shall be
                          deemed to refer to the relevant Concessionaire Brand
                          where your order relates to a contract with such
                          Concessionaire Brand or, alternatively, to boventraix
                          where your order relates to a contract with
                          boventraix.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you are a customer in the European Economic Area
                          (EEA) and you order an item online, you get 14
                          calendar days to cancel your order because you have
                          changed your mind. This cancellation period starts
                          from the day you have received all of the items in
                          your order. Find out how to return your item(s) under
                          the “How to return an item” heading below. For the
                          avoidance of doubt, your right to cancel does not
                          apply to an in-store purchase.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For the avoidance of doubt, your right to cancel does
                          not apply to:
                        </p>
                      </div>
                      <ul>
                        <li>an in-store purchase;</li>
                        <li>
                          perishable items (including but not limited to food,
                          alcohol or flowers);
                        </li>
                        <li>
                          unwrapped computer software (including CDs and DVDs);
                        </li>
                        <li>
                          custom-made items and personalised items; and vitamins
                          or supplements where the seal has been broken.
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you receive faulty goods, you may also have a right
                          to return these goods and/or to ask us to repair or
                          replace them or get a refund.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Items must be returned within 28 days of receipt.
                          Items bought in store can only be returned direct to
                          the store. Any boventraix products including beauty
                          which were purchased online can only be returned
                          online and will not be accepted in store.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For hygiene reasons, we cannot offer returns or
                          refunds on fashion face masks, cosmetics (including
                          beauty products), pierced jewellery, vitamins and
                          supplements, medicines, toiletries, swimwear or
                          lingerie if the product or item has been used, if the
                          hygiene or product seal has been broken or is no
                          longer in place or if the product is not in its
                          original packaging (if applicable), unless faulty.
                          Items of footwear and/or clothing must be unworn and
                          unwashed with the original labels attached. Items of
                          homeware including bedlinen, mattresses and toppers,
                          and pillows must be unused and in their original
                          unopened packaging. This does not affect your
                          statutory rights. Also, footwear must be tried on
                          indoors.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For furniture returns, items must be in new and unused
                          condition, unassembled and in their original
                          packaging. We do not offer any refund or return in
                          respect of:
                        </p>
                      </div>
                      <ul>
                        <li>
                          products which are not returned in a saleable
                          condition;
                        </li>
                        <li>
                          perishable items (including but not limited to food,
                          alcohol or flowers);
                        </li>
                        <li>
                          unwrapped computer software (including CDs and DVDs);
                        </li>
                        <li>
                          custom-made items and personalised items; and vitamins
                          or supplements where the seal has been broken.
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Where we suspect fraudulent activity, including but
                          not limited to circumstances where there are
                          suspicious claims relating to orders having been
                          placed, but not received, or if we suspect that you
                          are returning items after they have been used or worn,
                          or items returned do not match what you ordered, we
                          reserve the right to withhold refunds and block your
                          account (and any associated accounts) from placing
                          orders in future. If this happens to you and you think
                          we’ve made a mistake, you can Contact Us and we will
                          discuss the matter with you further.
                        </p>
                      </div>
                      <h2>Faulty Goods</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We’re really sorry to hear that you’ve received an
                          item that’s not in perfect condition. So that we can
                          get this fixed for you please head over to our{" "}
                          <Link onClick={toTop} to="/contact">
                            Contact Us
                          </Link>{" "}
                          section.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          To help us get this fixed for you ASAP, when you first
                          contact us please include the following information;
                        </p>
                      </div>
                      <ul>
                        <li>Your name</li>
                        <li>Order number</li>
                        <li>Product name and code</li>
                        <li>Picture of the fault</li>
                        <li>Description of the fault</li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (The product name and code can be found on your order
                          confirmation email).
                        </p>
                      </div>
                      <h2>Can I have an exchange instead of a refund?</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Unfortunately we don't offer an exchange facility.
                          Simply return your item(s) and reorder for a
                          replacement. Your refund will be processed once we've
                          received your unwanted items.
                        </p>
                      </div>
                      <h2>
                        Cancelling a contract under the consumer contracts
                        regulations (online orders only)
                      </h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you’re a customer in the UK or EEA, you have the
                          legal right to cancel your contract if you change your
                          mind until 14 days after you receive (or someone you
                          nominate receives) the products, unless the products
                          are split into several deliveries over different days.
                          In this case you will have until 14 days after the day
                          you (or someone you nominate) receives the last
                          product ordered under that contract.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For the avoidance of doubt, your right to cancel does
                          not apply to:
                        </p>
                      </div>
                      <ul>
                        <li>an in-store purchase;</li>
                        <li>
                          perishable items (including but not limited to food,
                          alcohol or flowers);
                        </li>
                        <li>
                          unwrapped computer software (including CDs and DVDs);
                        </li>
                        <li>
                          custom-made items and personalised items; and vitamins
                          or supplements where the seal has been broken.
                        </li>
                      </ul>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you wish to cancel a contract under this section,
                          you just need to communicate this to us within the
                          timescale set out above. If you wish to cancel a
                          Contract with Debenhams.com Online Limited and/or the
                          Concession Brand, the easiest way to do this is to
                          contact us by email at{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          . If you wish to cancel a Contract with DBZ
                          Marketplace Online Limited. You may use a copy of the
                          cancellation form available here, but you are not
                          required to do so.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you’re cancelling your contract with us but have
                          already received your order, you’ll need to return the
                          item(s) to us, see how to do this below. You'll then
                          receive a full refund as per the policy above.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Please note, we cannot offer refunds on cosmetics and
                          pierced jewellery or on swimwear and lingerie (if the
                          hygiene seal is not in place or has been broken).
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          All returns are quality checked – items should be
                          returned in a new and unused condition with labels and
                          tags attached and wherever possible sent back in the
                          original packaging. Refunds will not be given if they
                          do not comply with our returns policy.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          For the avoidance of doubt, your right to cancel does
                          not apply to an in-store purchase.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Returns;
